import { CurrencyAmount, HYDRA, JSBI } from 'hydra/sdk'
import { MIN_HYDRA } from '../constants'

/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */
export function maxAmountSpend(currencyAmount?: CurrencyAmount): CurrencyAmount | undefined {
  if (!currencyAmount) return undefined
  if (currencyAmount.currency === HYDRA) {
    if (JSBI.greaterThan(currencyAmount.raw, MIN_HYDRA)) {
      return CurrencyAmount.hydra(JSBI.subtract(currencyAmount.raw, MIN_HYDRA))
    } else {
      return CurrencyAmount.hydra(JSBI.BigInt(0))
    }
  }
  return currencyAmount
}
